import { Head, useForm, Link, usePage } from '@inertiajs/inertia-react'
import { Card, Form, Button, Table, Row, Col, Container, Modal } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import { Inertia } from '@inertiajs/inertia'

const Index = ({ fieldTrainers, commissions, selectedAdviserId }) => {
    const { flash } = usePage().props
    const [showRecalculateModal, setShowRecalculateModal] = useState(false)
    const [selectedCommissionId, setSelectedCommissionId] = useState(null)
    const { data, setData, post, processing } = useForm({
        adviser_id: selectedAdviserId || '',
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
    })

    const months = [
        { value: 1, label: 'Enero' },
        { value: 2, label: 'Febrero' },
        { value: 3, label: 'Marzo' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Mayo' },
        { value: 6, label: 'Junio' },
        { value: 7, label: 'Julio' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Septiembre' },
        { value: 10, label: 'Octubre' },
        { value: 11, label: 'Noviembre' },
        { value: 12, label: 'Diciembre' }
    ]

    const getFullName = (adviser) => {
        return `${adviser.user_name} ${adviser.lastname_ap} ${adviser.lastname_am}`.trim()
    }

    const getMonthName = (monthNumber) => {
        const month = months.find(m => m.value === monthNumber)
        return month ? month.label : monthNumber
    }

    const handleAdviserChange = (e) => {
        const adviserId = e.target.value
        setData('adviser_id', adviserId)

        if (adviserId) {
            Inertia.get(route('field-trainer-commissions.index'),
                { adviser_id: adviserId },
                { preserveState: true, preserveScroll: true }
            )
        }
    }

    const handleGenerateCommission = (e) => {
        e.preventDefault()
        post(route('field-trainer-commissions.calculate'), {
            preserveScroll: true
        })
    }

    const handleOpenRecalculateModal = (commissionId) => {
        setSelectedCommissionId(commissionId)
        setShowRecalculateModal(true)
    }

    const handleCloseRecalculateModal = () => {
        setShowRecalculateModal(false)
        setSelectedCommissionId(null)
    }

    const handleConfirmRecalculate = () => {
        if (!selectedCommissionId) {
            return
        }

        Inertia.post(route('field-trainer-commissions.recalculate', selectedCommissionId), {}, {
            preserveScroll: true
        })

        handleCloseRecalculateModal()
    }

    const years = []
    const currentYear = new Date().getFullYear()
    for (let i = currentYear; i >= 2020; i--) {
        years.push(i)
    }

    return (
        <>
            <Row>
                <div className="mb-7 mt-7">
                    <Breadcrumbs currentPath="/admin/field-trainer-commissions" />
                </div>

                <Col className="mb-2 px-1">
                    <h2>Comisiones Field Trainer</h2>
                </Col>

                {flash?.success && (
                    <AlertDismissible
                        message={flash.success}
                        type="success"
                    />
                )}

                {flash?.error && (
                    <AlertDismissible
                        message={flash.error}
                        type="danger"
                    />
                )}

                <Container>
                    <Card className="mb-4">
                        <Card.Body>
                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Seleccionar Field Trainer</Form.Label>
                                        <Form.Select
                                            value={data.adviser_id}
                                            onChange={handleAdviserChange}
                                        >
                                            <option value="">Selecciona un Field Trainer</option>
                                            {fieldTrainers.map((adviser) => (
                                                <option key={adviser.id} value={adviser.id}>
                                                    {getFullName(adviser)}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {data.adviser_id && (
                                <Row className="align-items-end">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Mes</Form.Label>
                                            <Form.Select
                                                value={data.month}
                                                onChange={e => setData('month', e.target.value)}
                                            >
                                                {months.map((month) => (
                                                    <option key={month.value} value={month.value}>
                                                        {month.label}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Año</Form.Label>
                                            <Form.Select
                                                value={data.year}
                                                onChange={e => setData('year', e.target.value)}
                                            >
                                                {years.map((year) => (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Button
                                            variant="primary"
                                            onClick={handleGenerateCommission}
                                            disabled={processing || !data.adviser_id}
                                        >
                                            {processing ? 'Generando...' : 'Generar Comisión Mensual'}
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>

                    {data.adviser_id && commissions?.data && commissions.data.length > 0 && (
                        <Card>
                            <Card.Body>
                                <Card.Title>Historial de Comisiones</Card.Title>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Mes</th>
                                            <th>Año</th>
                                            <th>Tipo Comisión</th>
                                            <th>Porcentaje de Comisión</th>
                                            <th>Suma Montos</th>
                                            <th>Fecha de Creación</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {commissions.data.map((commission) => (
                                            <tr key={commission.id}>
                                                <td>{getMonthName(commission.month)}</td>
                                                <td>{commission.year}</td>
                                                <td>{commission.tier_name || 'N/A'}</td>
                                                <td>{commission.commission_percentage}%</td>
                                                <td>
                                                    {Number(commission.commission_amount || 0).toLocaleString('es-MX', {
                                                        style: 'currency',
                                                        currency: 'MXN'
                                                    })}
                                                </td>
                                                <td>{new Date(commission.created_at).toLocaleDateString('es-MX')}</td>
                                                <td>
                                                    {!commission.used && (
                                                        <Button
                                                            size="sm"
                                                            variant="warning"
                                                            onClick={() => handleOpenRecalculateModal(commission.id)}
                                                        >
                                                            Recalcular
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                {/* Pagination */}
                                {commissions.links && commissions.links.length > 3 && (
                                    <div className="d-flex justify-content-center mt-3">
                                        <nav>
                                            <ul className="pagination">
                                                {commissions.links.map((link, index) => (
                                                    <li
                                                        key={index}
                                                        className={`page-item ${link.active ? 'active' : ''} ${!link.url ? 'disabled' : ''}`}
                                                    >
                                                        {link.url ? (
                                                            <Link
                                                                href={link.url}
                                                                className="page-link"
                                                                dangerouslySetInnerHTML={{ __html: link.label }}
                                                            />
                                                        ) : (
                                                            <span
                                                                className="page-link"
                                                                dangerouslySetInnerHTML={{ __html: link.label }}
                                                            />
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        </nav>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    )}

                    {data.adviser_id && commissions?.data && commissions.data.length === 0 && (
                        <Card>
                            <Card.Body>
                                <p className="text-center text-muted">No hay comisiones registradas para este Field Trainer.</p>
                            </Card.Body>
                        </Card>
                    )}
                </Container>

                <Modal show={showRecalculateModal} onHide={handleCloseRecalculateModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmar recálculo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿En realidad quieres recalcular el monto de la comisión?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseRecalculateModal}>
                            Cancelar
                        </Button>
                        <Button variant="warning" onClick={handleConfirmRecalculate}>
                            Sí, recalcular
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Row>
        </>
    )
}

Index.layout = page => <Layout children={page} />

export default Index
